import common from './common.json';
//auth
import auth from './auth/auth.json';
import logIn from './auth/login.json';
import userAccount from './main/userAccount.json';
import createPassword from './auth/createPassword.json';
import forgotPassword from './auth/forgotPassword.json';
import incidents from './incidents.json';
//organization
import organization from './organization/organization.json';
import kms from './kms.json';
//reports
import reports from './reports/reports.json';
import assets from './assets/assets.json';
import assetCustomFields from './asset-custom-fields/asset-custom-fields.json';
import manualUpload from './manualUpload.json';
import sites from './sites/sites.json';
import logsExport from './logsExport.json';
import maintenance from './maintenance.json';
import navigation from './navigation.json';
import sessions from './sessions.json';
import pipelineDebug from './pipeline-debug/pipeline-debug.json';
import settings from './settings/settings.json';
import dashboard from './main/dashboard.json';

// organization relationship
import organizationRelationship from './organization-relationship/organization-relationship.json';
import componentSchema from './componentSchema.json';
import userManagement from './user-management/user-management.json';
import authorization from './authorization/authorization.json';
import sla from './sla/sla.json';
import errorManagement from './errorManagement.json';
import diagnosticRules from './diagnosticRules.json';

export const frTranslationResources = {
  auth,
  common,
  forgotPassword,
  logIn,
  createPassword,
  incidents,
  userAccount,
  organization,
  kms,
  reports,
  assets,
  organizationRelationship,
  componentSchema,
  assetCustomFields,
  maintenance,
  manualUpload,
  sites,
  navigation,
  sessions,
  settings,
  userManagement,
  authorization,
  sla,
  pipelineDebug,
  logsExport,
  dashboard,
  errorManagement,
  diagnosticRules,
};
